import {legacy_createStore as createStore, applyMiddleware, Middleware} from "redux";
import {createLogger} from "redux-logger";
import {thunk} from "redux-thunk";
import promise from "redux-promise-middleware";
import rootReducer from "./redux/rootReducer";

const logger = createLogger({
    predicate: () => false // set to true for logging
});

const middleware = applyMiddleware(
    promise as Middleware,
    thunk as Middleware,
    logger as Middleware
);

export const store = createStore(rootReducer, undefined, middleware);
